/**
 * NATS cache-invalidation protocol.
 *
 * Subject: `workspaces.{workspaceId}.notifications.cache.invalidation`
 *
 * Each event is a self-contained typed object — no loose context bags, no
 * dynamic action arrays. Adding a new event = add a new interface + union
 * member. The frontend switch on `type` gets full TypeScript narrowing and
 * knows exactly which fields are available for each event.
 */
export const CACHE_INVALIDATION_SUBJECT = "cache.invalidation";

// ── Shared base ─────────────────────────────────────────────────────────────

interface CacheEventBase {
    workspaceId: string;
}

// ── Billing events ───────────────────────────────────────────────────────────

/**
 * Published after an entity crosses the 250-transaction threshold during a
 * recalculation job. The frontend should refetch workspace billing status so
 * `useBillingStatus` returns an up-to-date `transactionCount`.
 */
export interface WorkspaceStatusChangedEvent extends CacheEventBase {
    type: "workspace.status.changed";
}

// ── Union ────────────────────────────────────────────────────────────────────

/**
 * All supported cache-invalidation events. Add new members here when a new
 * domain needs live-update support.
 */
export type CacheInvalidationEvent = WorkspaceStatusChangedEvent;
